import { createSelector } from 'reselect';

export const dashboardSelector = state => state.dashboard;
export const reportsFilterSelector = createSelector(dashboardSelector, dashboard => dashboard.reportsFilter);
